import React from 'react';
import { useSelector } from 'react-redux';
import {
    BarChart,
    BarChart2,
    Box,
    Briefcase,
    Calendar,
    CheckCircle,
    MapPin,
    MessageSquare,
    Package,
    ShoppingCart,
    Target,
    Trello,
    Users,
    Database,
    Smartphone,
    ChevronDown,
    HelpCircle,
    Settings,
} from 'react-feather';
import { Dropdown } from '../../../shared/components/Dropdown/Dropdown';
import { translate } from '../../../shared/translations';
import {
    sanitizePropertyValue,
    navItems,
    H5,
} from '../../../shared/theme/styles';
import { testID } from '../../../shared/utils/integrationTesting/integrationTesting';
import { navTestId } from '../../../constants/testIds';

const iconSize = 24;
const iconColor = sanitizePropertyValue('--gray-500');

const menuConfig = {
    dashboard: {
        icon: (<Trello color={iconColor} size={iconSize} />),
    },
    reps: {
        icon: (<Smartphone color={iconColor} size={iconSize} />),
    },
    users: {
        icon: (<Users color={iconColor} size={iconSize} />),
    },
    locations: {
        icon: (<MapPin color={iconColor} size={iconSize} />),
    },
    locationsHub: {
        icon: (<MapPin color={iconColor} size={iconSize} />),
    },
    work: {
        icon: (<Briefcase color={iconColor} size={iconSize} />),
    },
    workHub: {
        icon: (<Briefcase color={iconColor} size={iconSize} />),
    },
    mPlans: {
        icon: null,
    },
    hotTasks: {
        icon: null,
    },
    tools: {
        icon: null,
    },
    reportingCenter: {
        icon: (<BarChart2 color={iconColor} size={iconSize} />),
    },
    legacyReportingCenter: {
        icon: (<BarChart2 color={iconColor} size={iconSize} />),
    },
    itemManager: {
        icon: (<Box color={iconColor} size={iconSize} />),
    },
    scheduling: {
        icon: (<Calendar color={iconColor} size={iconSize} />),
    },
    planning: {
        icon: (<Target color={iconColor} size={iconSize} />),
    },
    executionDashboard: {
        icon: (<CheckCircle color={iconColor} size={iconSize} />),
    },
    communications: {
        icon: (<MessageSquare color={iconColor} size={iconSize} />),
    },
    looker: {
        icon: (<BarChart color={iconColor} size={iconSize} />),
    },
    manufacturers: {
        icon: (<Package color={iconColor} size={iconSize} />),
    },
    retailers: {
        icon: (<ShoppingCart color={iconColor} size={iconSize} />),
    },
    stores: {
        icon: (<MapPin color={iconColor} size={iconSize} />),
    },
    dataWarehouse: {
        icon: (<Database color={iconColor} size={iconSize} />),
    },
    preferences: {
        icon: (<Settings color={iconColor} size={iconSize} />),
    },
};

const defaultIcon = (<HelpCircle color={iconColor} size={iconSize} />);

const matchLocPathname = (subOption) => subOption.url === window.location.pathname;

const hamburgerMap = (option, index) => {
    if (option.subOptions && Array.isArray(option.subOptions)) {
        return {
            ...testID(navTestId[option.key]),
            key: index,
            text: (
                <span className="selectedActionText" style={H5}>
                    {translate(option.translationKey)}
                    <ChevronDown color={iconColor} className="dropdownIcon rotateOnOpen" alt="Dropdown icon" strokeWidth="3px" size="16px" />
                </span>
            ),
            icon: (menuConfig[option.key]?.icon || defaultIcon),
            leftIcon: true,
            currentActive: (option.subOptions.some(matchLocPathname)),
            subOptions: option.subOptions,
        };
    }
    return {
        ...testID(navTestId[option.key]),
        key: index,
        text: (<span className="selectedActionText" style={H5}>{translate(option.translationKey)}</span>),
        icon: (menuConfig[option.key]?.icon || defaultIcon),
        leftIcon: true,
        currentActive: (window.location.pathname === option.url),
        onClick: () => { window.location = option.url; },
    };
};

const subOptionsAnchorMap = (option) => ({
    ...testID(navTestId[option.key]),
    key: option.key,
    text: translate(option.translationKey),
    onClick: () => { window.location.href = option.url; },
});

export const anchorMap = (option) => {
    if (option.subOptions && Array.isArray(option.subOptions)) {
        return (
            <Dropdown
                className={option.subOptions.some(matchLocPathname) && 'currentActive'}
                {...testID(navTestId[option.key])}
                text={translate(option.translationKey)}
                dropdownButtonStyle="menu"
                alignRigth={false}
                iconType="chevron"
                dropdownType="dropdownAction"
                options={option.subOptions.map(subOptionsAnchorMap)}
            />
        );
    }
    return (
        <a
            {...testID(navTestId[option.key])}
            className={window.location.pathname === option.url && 'currentActive'}
            key={option.key}
            href={option.url}
            style={navItems}
        >
            {translate(option.translationKey)}
        </a>
    );
};

export const DesktopNavOptions = () => {
    const headerNavOptions = useSelector((state) => state.navigationOptions.header);
    return (
        <div className="nav-options">
            {headerNavOptions.map(anchorMap)}
        </div>
    );
};

export const MobileNavOptions = (navOptions) => navOptions.map(hamburgerMap);
